import axios from 'axios';
import { clearAllCookies, clearItem, getItem } from '../view/Utils/CommonFunction/CommonFunction';
import { USERS_CONFIRM_URL } from '../common/config';

const prepareHeaders = () => {
  const accessToken = getItem('accessToken');
  return {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  };
};

export const UserConfirmService = async (payload) => {
  try {
    const response = await axios({
      method: 'post',
      url: USERS_CONFIRM_URL,
      headers: prepareHeaders().headers,
      data: payload,
    });
    return response;
  } catch (error) {
    if (error?.response?.status == 401) {
      window.location.reload()
      clearAllCookies();
      clearItem();
    }
    return error;
  }
};
